<template>
    <div>
        <div class="vx-row">
            <vx-card title="Edit SVD Location Mapping" class="mb-4 pb-5">
                <!-- Merchant  -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Merchant</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required v-model="selected_merchant" :options="merchant_list" name="Merchant"
                            placeholder="Please Select Merchant" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Merchant')">{{
                            errors.first('Merchant')
                        }}
                        </span>

                    </div>
                </div>

                <!--Payment Channel -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Location Mapping</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required id="Location Mapping" v-model="selected_location_mapping"
                            placeholder="Please Select Location Mapping" name="Location Mapping"
                            :options="location_mapping_list" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Location Mapping')">{{
                            errors.first('Location Mapping')
                        }}</span>
                    </div>
                </div>

                <!-- action button -->
                <div class="w-full text-right  p-4">
                    <vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
                    <vs-button id="btn-submit" class="ml-4" @click.prevent="showConfirmDialog">Submit</vs-button>
                    <vs-popup title="Are you sure with this data?" :active.sync="popupActivo">
                        Before : <br />
                        PTO Name : <b>{{ this.$route.params.currentSVDLocationMapping.pto_name }}</b><br />
                        Merchant ID : <b>{{ this.$route.params.currentSVDLocationMapping.merchant_id }}</b><br />
                        Merchant Code : <b>{{ this.$route.params.currentSVDLocationMapping.merchant_code }}</b><br />
                        Merchant Name : <b>{{ this.$route.params.currentSVDLocationMapping.merchant_name }}</b><br />
                        Location ID : <b>{{ this.$route.params.currentSVDLocationMapping.location_id }}</b><br />
                        Location Name : <b>{{ this.$route.params.currentSVDLocationMapping.location_name }}</b><br />
                        After : <br />
                        PTO Name : <b>{{ this.selected_location_mapping.pto_name }}</b><br />
                        Merchant ID : <b>{{ this.selected_merchant.merchant_id }}</b><br />
                        Merchant Code : <b>{{ this.selected_merchant.code }}</b><br />
                        Merchant Name : <b>{{ this.selected_merchant.label }}</b><br />
                        Location ID : <b>{{ this.selected_location_mapping.location_id }}</b><br />
                        Location Name : <b>{{ this.selected_location_mapping.location_name }}</b><br />
                        <div class="w-full text-right">
                            <vs-button id="btn-submit" class="mt-5 ml-4" @click.prevent="submitForm">Submit</vs-button>
                        </div>
                    </vs-popup>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import AxiosCall from "@/global/AxiosCall";
import { url } from "@/configs/apiUrl";
export default {
    name: "AddSVDLocationMapping",
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            merchant_list: [],
            location_mapping_list: [],
            selected_merchant: [],
            selected_location_mapping: [],
            popupActivo: false,
        }
    },
    methods: {
        backPage() {
            this.$router.push({ name: 'SVDLocationMapping' })
        },
        showConfirmDialog() {
            this.$validator.validateAll()
                .then((res) => {
                    if (res) {
                        this.popupActivo = true;
                    }
                })
        },
        submitForm() {
            this.$validator.validateAll()
                .then((res) => {
                    this.popupActivo = false;
                    if (res) {
                        let payload = {
                            merchant_id: this.selected_merchant.merchant_id,
                            location_id: this.selected_location_mapping.location_id
                        }
                        AxiosCall.Put(url.svd.svd_location_mapping.update + this.$route.params.svdlocationMappingId, payload)
                            .then((res) => {
                                if (res.message_code === 'E_INVALID_PARAMETER') {
                                    this.$vs.notify({
                                        title: "Warning",
                                        text: res.message,
                                        iconPack: "feather",
                                        icon: "icon-alert-circle",
                                        color: "warning",
                                        position: "top-right"
                                    });
                                } else {
                                    this.$store.dispatch('createAuditTrail', {
                                        user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                        session_id: parseInt(localStorage.getItem('sessID')),
                                        user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                        menu: "Location Mapping",
                                        activity: "Add location mapping",
                                        data_before: {},
                                        data_after: payload,
                                    })
                                    let status = true
                                    this.$router.push({ name: "SVDLocationMapping", params: { status: status, message: "Add SVD location mapping success" } })
                                }
                            }, (error) => {
                                this.$vs.notify(error.response.data.notify)
                            })
                    }
                })
        }
    },
    mounted() {
        if (this.$route.params.svdlocationMappingId === undefined) {
            location.href = "/svd-location-mapping"
        } else {
            // initial value for pto merchant
            this.selected_merchant = {
                label: this.$route.params.currentSVDLocationMapping.merchant_name,
                code: this.$route.params.currentSVDLocationMapping.merchant_code,
                merchant_id: this.$route.params.currentSVDLocationMapping.merchant_id,
            }
            this.selected_location_mapping = {
                label: this.$route.params.currentSVDLocationMapping.location_id + ' - ' + this.$route.params.currentSVDLocationMapping.location_name,
                location_id: this.$route.params.currentSVDLocationMapping.location_id,
                location_name: this.$route.params.currentSVDLocationMapping.location_name,
                pto_name: this.$route.params.currentSVDLocationMapping.pto_name

            }

        }

        // get merchant list
        AxiosCall.Get(url.svd.merchant.combo).then(resp => {
            for (let data of resp.data) {
                if (data.depth > 2) {
                    this.merchant_list.push({
                        label: data.full_name,
                        code: data.code,
                        merchant_id: data.id
                    })
                }
            }
        })

        let newUrl = url.svd.location_mapping.list + "?page=1&limit=99999999"
        AxiosCall.Get(newUrl).then(resp => {
            for (let data of resp.data.data) {
                let pto_name = "";
                if (data.loc_id != '') {
                    switch (data.loc_id[0]) {
                        case '1':
                            pto_name = "KCI";
                            break
                        case '2':
                            pto_name = "TJ";
                            break
                        case '3':
                            pto_name = "MRT";
                            break
                        case '4':
                            pto_name = "LRT";
                            break
                    }
                }
                this.location_mapping_list.push({
                    label: data.loc_id + " - " + data.loc_name,
                    location_id: data.loc_id,
                    location_name: data.loc_name,
                    pto_name: pto_name
                })
            }
        })
    }
}
</script>

<style>
.con-vs-popup .vs-popup {
    width: 350px !important;
    height: auto !important;
}
</style>
